<template>
  <div>
    <div v-if="!embed" class="row">
      <div class="col-lg-12 col-xxl-12">
        <div class="card card-custom card-stretch gutter-b">
          <div class="card-body pb-10 pt-10 page-container">
            <div class="d-flex align-items-center mb-5">
              <b-button variant="light" class="mr-3" @click="goBack">
                {{ $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.MEMBERS.BTN_BACK") }}
              </b-button>
              <h4 class="mb-0">
                {{
                  $t(
                    "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.MEMBERS.PAGE_POINTS_TITLE"
                  )
                }}
              </h4>
            </div>
            <campaign-member-point-history-body
              :loading="loading"
              :error="error"
              :busy="busy"
              :items="items"
              :page="page"
              :per-page="perPage"
              :total-rows="totalRows"
              :per-page-options="perPageOptions"
              @page-input="onPageInput"
              @per-page-change="onPerPageChange"
            />
          </div>
        </div>
      </div>
    </div>
    <campaign-member-point-history-body
      v-else
      :loading="loading"
      :error="error"
      :busy="busy"
      :items="items"
      :page="page"
      :per-page="perPage"
      :total-rows="totalRows"
      :per-page-options="perPageOptions"
      @page-input="onPageInput"
      @per-page-change="onPerPageChange"
    />
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import CampaignMemberPointHistoryBody from "./CampaignMemberPointHistoryBody.vue";

export default {
  name: "CampaignMemberPointHistory",
  components: {
    CampaignMemberPointHistoryBody
  },
  props: {
    embed: {
      type: Boolean,
      default: false
    },
    campaignId: {
      type: [String, Number],
      default: null
    },
    customerCampaignId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      loading: false,
      error: false,
      busy: false,
      items: [],
      page: 1,
      perPage: 25,
      perPageOptions: [25, 50, 100],
      totalRows: 0
    };
  },
  computed: {
    resolvedCampaignId() {
      if (this.embed && this.campaignId != null && this.campaignId !== "") {
        return this.campaignId;
      }
      return this.$route.params.campaignId;
    },
    resolvedCustomerCampaignId() {
      if (
        this.embed &&
        this.customerCampaignId != null &&
        this.customerCampaignId !== ""
      ) {
        return this.customerCampaignId;
      }
      return this.$route.params.customerCampaignId;
    }
  },
  mounted() {
    if (!this.embed) {
      this.$store.dispatch(SET_BREADCRUMB, [
        {
          title: `${this.$t("MENU.CAMPAIGN_MANAGEMENT.CAMPAIGN")}`,
          route: "/campaign"
        },
        {
          title: `${this.$t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TITLE")}`,
          route: `/campaign/form/campaign_receipt/${this.resolvedCampaignId}`
        },
        {
          title: `${this.$t(
            "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.MEMBERS.PAGE_POINTS_TITLE"
          )}`
        }
      ]);
    }
    this.fetchList();
  },
  methods: {
    onPageInput(nextPage) {
      this.page = nextPage;
      this.fetchList();
    },
    onPerPageChange(nextPerPage) {
      this.perPage =
        typeof nextPerPage === "number"
          ? nextPerPage
          : parseInt(nextPerPage, 10) || 25;
      this.page = 1;
      this.fetchList();
    },
    async fetchList() {
      this.loading = this.items.length < 1;
      this.busy = true;
      this.error = false;
      try {
        ApiService.setHeader();
        const { data } = await ApiService.getParams(
          `campaign/${this.resolvedCampaignId}/members/${this.resolvedCustomerCampaignId}/point_history`,
          {
            params: {
              page: String(this.page),
              perPage: String(this.perPage)
            }
          }
        );
        if (data.status === "success" && data.data) {
          this.items = data.data.data || [];
          this.totalRows =
            data.data.total != null ? Number(data.data.total) : 0;
        } else {
          this.items = [];
          this.totalRows = 0;
          this.error = true;
        }
      } catch (e) {
        this.items = [];
        this.totalRows = 0;
        this.error = true;
      } finally {
        this.loading = false;
        this.busy = false;
      }
    },
    goBack() {
      this.$router.push(
        `/campaign/form/campaign_receipt/${this.resolvedCampaignId}`
      );
    }
  }
};
</script>
